import { render, staticRenderFns } from "./OfferExpenses.vue?vue&type=template&id=1b2a1334&scoped=true"
import script from "./OfferExpenses.vue?vue&type=script&lang=js"
export * from "./OfferExpenses.vue?vue&type=script&lang=js"
import style0 from "./OfferExpenses.vue?vue&type=style&index=0&id=1b2a1334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2a1334",
  null
  
)

export default component.exports